import { ChangeDetectionStrategy, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ResourceOpportunity } from '@klickdata/core/opportunity';

@Component({
    selector: 'app-occasion-spend-time',
    templateUrl: './occasion-spend-time.component.html',
    styleUrls: ['./occasion-spend-time.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OccasionSpendTimeComponent),
            multi: true,
        },
    ],
})
export class OccasionSpendTimeComponent implements OnInit, ControlValueAccessor {
    @Input() occasion: ResourceOpportunity;
    @Input() label: string;
    public expanded: boolean;
    public timeSpendForm: FormGroup;
    protected _value: any;

    constructor(protected fb: FormBuilder) {}

    ngOnInit(): void {
        this.timeSpendForm = this.fb.group({
            minutes: [0],
            hours: [0],
        });
        if (this.occasion) {
            const startedAt = new Date(this.occasion.created_at.toDate());
            const now = new Date();
            const diffMs = now.getTime() - startedAt.getTime();
            const diffMins = Math.floor(diffMs / 60000); // Convert ms to minutes
            const hours = Math.floor(diffMins / 60);
            const minutes = diffMins % 60;
            this.timeSpendForm.patchValue({
                minutes: !minutes && !hours ? 1 : minutes,
                hours: hours,
            });
            this.propagate();
        }
        this.timeSpendForm.valueChanges.subscribe((value) => this.propagate());
    }
    propagate() {
        this.propagateChange(this.timeSpendForm.value.hours * 60 + this.timeSpendForm.value.minutes);
    }

    propagateChange = (_: any) => {};

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {}

    writeValue(value: any): void {}
}
